export default __webpack_public_path__ + "static/media/img--design-7.99dea4b0.jpg";